import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=65d3b004&lang=true&"
import script from "./Atlas.vue?vue&type=script&lang=js&"
export * from "./Atlas.vue?vue&type=script&lang=js&"
import style0 from "./Atlas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports